import type { AssessmentLevel } from './types'

// 数値・文言は business-assessment.html のモックから1文字も変えずに移植している。
export const LEVELS: AssessmentLevel[] = [
  {
    min: 0,
    max: 39,
    phase: 1,
    name: '属人依存型',
    copy: '人が成果を作る組織',
    color: '#A83232',
    desc: '成果の源泉が個人に依存している状態です。優秀な個人の経験や努力によって成果が出ている一方で、ノウハウが組織に蓄積されにくく、人の異動や退職によって成果が大きく変動するリスクがあります。',
  },
  {
    min: 40,
    max: 59,
    phase: 2,
    name: 'チーム依存型',
    copy: '強いチームが成果を作る組織',
    color: '#C2662D',
    desc: '一部のチームや管理職によって成果が生み出されている状態です。成果を出せるチームは存在するものの、そのやり方が組織全体に展開されておらず、チーム間で成果や育成品質にばらつきが生まれやすい状態です。',
  },
  {
    min: 60,
    max: 74,
    phase: 3,
    name: '標準化型',
    copy: '仕組みが成果を作る組織',
    color: '#B08A2E',
    desc: '成果を生み出すための基本的な型が整備されている状態です。誰が担当しても一定水準の成果を出しやすい状態です。',
  },
  {
    min: 75,
    max: 89,
    phase: 4,
    name: '学習型',
    copy: '組織が学習しながら成果を作る組織',
    color: '#3C6E9E',
    desc: '成果創出の仕組みが継続的に改善されている状態です。成功や失敗が組織に蓄積されナレッジとして共有されることで、組織全体が学習しながら成果を高め続けられています。',
  },
  {
    min: 90,
    max: 100,
    phase: 5,
    name: '自己進化型',
    copy: '組織が自ら進化し続ける組織',
    color: '#2E7D5B',
    desc: '組織そのものが競争優位になっている状態です。環境変化に合わせて仕組みが自律的に進化し、人が変わっても成果を出し続けられる状態です。',
  },
]
